import { CLOSE_WHATSAPP_CHAT, UPDATE_PATIENT_WHATSAPP_INFO, TOGGLE_WHATSAPP_CHAT } from "./ActionTypes";
import { WhatsAppPatientInfo } from "../components/WhatsAppChatComponent";

export class WhatsAppChatActions {
    static updateWhatsAppPatientInfo(patientInfo: WhatsAppPatientInfo) {
        return { type: UPDATE_PATIENT_WHATSAPP_INFO, patientInfo }
    }

    static toggleWhatsAppChat() {
        return { type: TOGGLE_WHATSAPP_CHAT }
    }

    static closeWhatsAppChat() {
        return { type: CLOSE_WHATSAPP_CHAT, windowVisible: false }
    }
}